import { Info } from "lucide-react";

/**
 * Section header for the report library — grid or enterprise (premium card) variant.
 */
export default function ReportLibraryHeader({
  title = "Report Library",
  subtitle,
  hint,
  variant = "grid",
}) {
  const content = (
    <>
      <div className="rpt-library-header__text">
        <h2 className="rpt-library-header__title">{title}</h2>
        {subtitle && <p className="rpt-library-header__subtitle">{subtitle}</p>}
      </div>
      {hint && (
        <aside className="rpt-library-header__hint" aria-label="Usage hint">
          <Info size={15} strokeWidth={2.25} aria-hidden="true" />
          <p>{hint}</p>
        </aside>
      )}
    </>
  );

  if (variant === "enterprise") {
    return (
      <section className="rpt-library-section rpt-library-section--enterprise" aria-label={title}>
        <div className="rpt-library-section__inner">{content}</div>
      </section>
    );
  }

  return <div className="rpt-library-header">{content}</div>;
}
